import { styled } from '@mui/material';

const StyledLocationContainer = styled('div')((props) => ({
  display: 'inline-flex',
  width: '100%',
  height: props.height || 'inherit',
  verticalAlign: 'top',
  border: `1px solid ${props.borderColor || '#d1d3d4'}`,
  borderRadius: '10px',
  backgroundColor: 'white',
  alignItems: 'center',
  padding: '10px',
  paddingLeft: '20px',
  svg: {
    fontSize: '18px'
  },
  input: {
    color: props.color || '#283237',
    fontSize: '14px',
    fontWeight: '325',
    lineHeight: '17px',
    border: 'none',
    padding: 0,
    marginRight: '6px'
  },
  '@media only screen and (max-width: 997px)': {
    width: '100%',
    borderRadius: '5px',
    '&:first-of-type': {
      borderRadius: '5px'
    }
  }
}));

export default StyledLocationContainer;
